import React, { useRef, useState } from "react";
import Slider from "react-slick";
// @ts-ignore
import "slick-carousel/slick/slick.css";
// @ts-ignore
import "slick-carousel/slick/slick-theme.css";
import ContactUsForm from "./ContactUsForm";

const TrustedIndustries = () => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const [isShow, setIsShow] = useState(false);

    const handleOpenDialog = () => {
        setIsShow(!isShow);
    };

    const smoothScroll = (container: HTMLDivElement, target: number, duration: number) => {
        const start = container.scrollLeft;
        const change = target - start;
        const startTime = performance.now();

        const animate = (currentTime: number) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1); // 0 → 1
            // easeInOutQuad easing
            const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
            container.scrollLeft = start + change * ease;

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    };


    const scrollRight = () => {
        const container = scrollContainerRef.current;
        if (!container) return;

        const slide = container.querySelector(".slide") as HTMLDivElement;
        if (!slide) return;

        const slideWidth = slide.offsetWidth + 6; // 36 = gap-9 in px
        smoothScroll(container, container.scrollLeft + slideWidth, 800); // 800ms = slow
    };

    const scrollLeft = () => {
        const container = scrollContainerRef.current;
        if (!container) return;

        const slide = container.querySelector(".slide") as HTMLDivElement;
        if (!slide) return;

        const slideWidth = slide.offsetWidth + 36;
        smoothScroll(container, container.scrollLeft - slideWidth, 800);
    };

    return (

        <section className="h-screen  m-auto m-0 bg-[rgba(15,15,15,1)] pt-[60px] pb-[60px] xl:pt-[120px] xl:pb-[120px]" id="industries">
            <div className="industries-block-1 w-full relative max-w-[1700px] m-auto m-0">
                <div className="inner-wrap pl-[25px] pr-[25px] lg:pl-[25px] lg:pr-[25px] xl:pl-[50px] xl:pr-[50px]">
                    <p className="tag-line relative leading-tight w-full flex-col lg:flex gap-14 items-end">
                        <div className="leading-tight">
                            <h2 className="text-[#f3daa3] text-[24px] sm:text-[24px] md:text-[30px] uppercase block pb-[30px]">
                                Trusted Industries
                            </h2>
                            <h3 className="font-semi-bold text-[#CACACA] text-[40px] sm:text-[46px] md:text-[72px] adjust-width w-full xl:w-3/4 inline-block">
                                Redefining Authenticity with <span className="text-[#C4A050]">Verified Value in Every Treasure</span>
                            </h3>
                        </div>
                        <div className="slide-holder flex flex-col xl:flex-row w-full h-1/2 min-h-[250px] xl:min-h-[500px] rounded-[25px] overflow-hidden">
                            <div className="left xl:w-[50%] min-h-[500px] xl:min-h-[500px] mt-[50px] xl:mt-[0]">
                                <span className="text-[#ffffff]"></span>
                            </div>
                            <div className="right xl:w-[50%] min-h-[250px]">
                                <div className="content-left w-full p-[30px] xl:p-[50px] xl:pr-[100px]">
                                    <div className="top mb-[30px] xl:w-[100%]">
                                        <h4 className="font-medium text-[#CACACA] text-[36px] sm:text-[36px] md:text-[52px]">
                                            High Jewellery Diamond & Gemstone Masterpieces
                                        </h4>
                                    </div>
                                    <div className="bottom flex flex-col w-auto">
                                        <p className="text-[#CACACA] text-[18px] md:text-[28px]">
                                            Blockchain verified authenticity for diamonds, gemstones and fine jewelry, elevating trust, transparency and brand prestige.
                                        </p>
                                        <button className="grey get-started cursor-pointer flex items-center gap-2 mt-[30px] w-auto self-start" onClick={handleOpenDialog}>
                                            <span>Contact us</span>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <rect width="24" height="24" rx="12" fill="black" />
                                                <path
                                                    d="M17 7L7 17M17 7H8M17 7V16"
                                                    stroke="white"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p>
                </div>
            </div>

            <ContactUsForm isShow={isShow} setIsShow={setIsShow} />
        </section>
    );
};

export default TrustedIndustries;